/* global window */

export default function AppVersionDialogController(
  $q,
  $scope,
  loaderService,
  ssDialogService,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleReload = _handleReload;

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleReload() {
    _closeDialog().then(() => {
      window.location.reload();
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.global.appVersionDialog);
  }
}

AppVersionDialogController.$inject = [
  '$q',
  '$scope',
  'loaderService',
  'ssDialogService',
];
